/** Blob URLs for attachments until the server media endpoint is ready. */
const cache = new Map<number, string>();

export function registerLocalMedia(messageId: number, blob: Blob): string {
  const prev = cache.get(messageId);
  if (prev) URL.revokeObjectURL(prev);
  const url = URL.createObjectURL(blob);
  cache.set(messageId, url);
  return url;
}

export function transferLocalMedia(fromId: number, toId: number): void {
  const url = cache.get(fromId);
  if (!url) return;
  cache.delete(fromId);
  const prev = cache.get(toId);
  if (prev && prev !== url) URL.revokeObjectURL(prev);
  cache.set(toId, url);
}

export function getLocalMediaUrl(messageId: number): string | undefined {
  return cache.get(messageId);
}

export function revokeLocalMedia(messageId: number): void {
  const url = cache.get(messageId);
  if (!url) return;
  URL.revokeObjectURL(url);
  cache.delete(messageId);
}

export function findNewestMediaMessage<
  T extends {
    id: number;
    message_type?: string;
    has_attachment?: boolean;
    attachment_size?: number;
  },
>(messages: T[], opts: { type: string; size?: number; afterId?: number }): T | undefined {
  let best: T | undefined;
  for (const m of messages) {
    if (m.id <= 0) continue;
    if (opts.afterId != null && m.id <= opts.afterId) continue;
    if (!m.has_attachment) continue;
    if ((m.message_type || 'text') !== opts.type) continue;
    if (opts.size != null && m.attachment_size != null && m.attachment_size !== opts.size) continue;
    if (!best || m.id > best.id) best = m;
  }
  return best;
}
